// @flow
import { GET_TEST_DATA, GET_TEST_DATA_SUCESS, API_ERROR } from "./actionTypes";

const INIT_STATE = {
  isLoading: false,
  datas: [],
  error: "",
  total: 0,
  bondDebtDatas: [],
};

const Test = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TEST_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case GET_TEST_DATA_SUCESS:
      return {
        ...state,
        error: "",
        datas: action.payload.datas,
        total: action.payload.total,
        bondDebtDatas: action.payload.bondDebtDatas,
        isLoading: false,
      };
    case API_ERROR:
      return {
        ...state,
        datas: [],
        error: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default Test;
